
const nrCustInteractionsState = {
   fromTime: '',
   toTime:'',
   fromPage: '',
   toPage:''
  }
  
  function updateNRTime(state = nrCustInteractionsState, action) {
      switch (action.type) {
          case 'UPDATE_NR_TIME':
              return Object.assign({}, state, action.value)        
          default:
              return state
      }

     /* function getState() {
        return state
      }*/
  }
  export default updateNRTime